import Vue from "vue";

// initial state
const state = {
  client: {},
  importer: {},
  project: {},
};

const getters = {
  client: (state) => {
    let result = {
      ClientName: state.client.ClientName || "",
      ClientGuid: state.client.ClientGuid || "",
    };
    return result;
  },
  importer: (state) => {
    let result = {
      ImporterName: state.importer.ImporterName || "",
      ImporterGuid: state.importer.ImporterGuid || "",
    };
    return result;
  },
  project: (state) => {
    let result = {
      ProjectName: state.project.ProjectName || "",
      ProjectGuid: state.project.ProjectGuid || "",
    };
    return result;
  },
};

const actions = {};

const mutations = {
  clearAll(state) {
    state.client = {};
    state.importer = {};
    state.project = {};
  },
  client(state, client) {
    client = client || {};
    Vue.set(state.client, "ClientName", client.ClientName || "");
    Vue.set(state.client, "ClientGuid", client.ClientGuid || "");
  },
  importer(state, importer) {
    importer = importer || {};
    Vue.set(state.importer, "ImporterName", importer.ImporterName || "");
    Vue.set(state.importer, "ImporterGuid", importer.ImporterGuid || "");
  },
  project(state, project) {
    project = project || {};
    Vue.set(state.project, "ProjectName", project.ProjectName || "");
    Vue.set(state.project, "ProjectGuid", project.ProjectGuid || "");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/sharedFilters.js